import React from "react";
import styled from "styled-components";
import { getI18n, withI18n } from "react-i18next";

const LegalSection = ({ t }) => {
  const isLangSpanish = getI18n().language === "es";
  const terms = isLangSpanish
    ? CWB_API_ENV.termsEs
    : `${CWB_API_ENV.domain}/terms_conditions.asp`;
  const privacy = isLangSpanish
    ? CWB_API_ENV.privacyEs
    : `${CWB_API_ENV.domain}/privacy.asp`;

  return (
    <Legal>
      <LegalItem>
        <StyledLink
          href={terms}
          rel="noopener noreferrer"
          target="_blank"
        >
          {t("Terms & Conditions")}
        </StyledLink>
      </LegalItem>
      <div style={{ color: "#ddd" }}>|</div>
      <LegalItem>
        <StyledLink
          href={privacy}
          rel="noopener noreferrer"
          target="_blank"
        >
          {t("Privacy Policy")}
        </StyledLink>
      </LegalItem>
    </Legal>
  );
};

export default withI18n()(LegalSection);

const StyledLink = styled.a`
  font-size: 12px;
  color: grey;
  font-weight: 600;
  text-decoration: none;
  display: block;
`;

const Legal = styled.div`
  text-align: center;
  padding-bottom: 8px;
  padding-top: 8px;
  border-top: 1px solid #ddd;
  display: flex;
  flex: none;
  width: 100%;
  justify-content: space-evenly;
  color: grey;
  line-height: 18px;
`;

const LegalItem = styled.div`
  width: 200px;
`;
